<app-system-message></app-system-message>
<div [ngClass]="theme.getThemeClass()" class="main-container card">
  <h2>{{ 'apiManagement' | translate }}</h2>

  <div class="api-form">
    <label class="label-spacer">{{ 'operatorApiKeyOperatorIdLabel' | translate }}:</label>
    <div class="api-key-wrapper">
      <input
        class="form-control api-key-input"
        type="text"
        name="operatorId"
        [value]="operatorId || ('operatorApiKeyNoOperatorId' | translate)"
        readonly
      />
      <button
        class="copy-btn"
        type="button"
        [disabled]="!hasOperatorId"
        (click)="copyOperatorId()"
        [attr.title]="'operatorApiKeyCopyOperatorId' | translate"
        [attr.aria-label]="'operatorApiKeyCopyOperatorId' | translate"
      >
        <i class="fas fa-copy"></i>
      </button>
    </div>

    <label class="label-spacer">{{ 'sidenavMenu.APIKEY' | translate }}:</label>
    <div class="api-key-wrapper">
      <input
        class="form-control api-key-input"
        type="text"
        name="operatorApiKey"
        [value]="maskedApiKey || ('operatorApiKeyNoKeyAvailable' | translate)"
        readonly
      />
      <button
        class="copy-btn"
        type="button"
        [disabled]="!hasApiKey"
        (click)="copyApiKey()"
        [attr.title]="'copyToClipBoard' | translate"
        [attr.aria-label]="'copyToClipBoard' | translate"
      >
        <i class="fas fa-copy"></i>
      </button>
    </div>

    @if (loading) {
      <label class="loading-label">{{ 'operatorApiKeyLoadingKey' | translate }}</label>
    }

    <div class="docs-links">
      <a
        class="doc-link"
        href="/assets/Public-API-Implementation-Guide.pdf"
        download="Public-API-Implementation-Guide.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'operatorApiKeyDownloadGuideEn' | translate }}
      </a>
      <a
        class="doc-link"
        href="/assets/Public-API-Implementation-Guide-FR.pdf"
        download="Public-API-Implementation-Guide-FR.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'operatorApiKeyDownloadGuideFr' | translate }}
      </a>
    </div>
  </div>
</div>
